import { ScreenerContext, withScreenerMachineState } from 'domains/signup/screener/context/screenerContext';

// note(juan): implement a proper error screen if its a common occurrence

const NoScreenerFound: React.FC = () => {
  const dob = ScreenerContext.useSelector(({ context }) => context.dob);

  throw new Error(`No screener found for the age of ${dob?.toString()}`);
};

export const ScreenerNoScreenerFound = withScreenerMachineState(NoScreenerFound, 'noScreenerFound');
